export class Adjunto {
  IdAdjunto: number;
  IdFormulario: number;
  NroFormulario: string;
  TipoArchivo: number;
  Nombre: string;
  Proceso: number;
  Estado: number;
  File: File;
  FileArray: any;
  NombreTipoArchivo: string;
  Tamanio: number;
  NombreTipoProceso: string;

  constructor(formID: number, nroForm: string, procesoID: number,
              nombre: string, file: File, fileArray: any,
              tipoArchivo: number, nombreTA: string, tamanio: number) {
    this.IdFormulario = formID;
    this.NroFormulario = nroForm;
    this.IdAdjunto = 0;
    this.Nombre = nombre;
    this.Proceso = procesoID;
    this.Estado = 0;
    this.File = file;
    this.FileArray = fileArray;
    this.TipoArchivo = tipoArchivo;
    this.NombreTipoArchivo = nombreTA;
    this.Tamanio = tamanio;
  }
}
